import { render, staticRenderFns } from "./Struk.vue?vue&type=template&id=49cae46a&scoped=true&"
import script from "./Struk.vue?vue&type=script&lang=js&"
export * from "./Struk.vue?vue&type=script&lang=js&"
import style0 from "./Struk.vue?vue&type=style&index=0&id=49cae46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cae46a",
  null
  
)

export default component.exports